import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { configuration } from 'src/environments/environment';
import { IEntityTypeConfig } from 'src/app/models/IEntityTypeConfig';

@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService {

  constructor(private http: HttpClient) { }

  // Get all insurance carriers from reference data
  getInsuranceCarriers(): Observable<any[]> {
    let url = configuration.apiUrl + 'referencedata/insurancecarriers';
    // append facility as query param
    const separator = url.includes('?') ? '&' : '?';
    url = `${url}${separator}facilityId=${sessionStorage.getItem('FacilityId')}`;
    return this.http.get<any[]>(url);
  }

  // Get the master Payer Class list from reference data
  getPayerClasses(): Observable<any[]> {
    let url = configuration.apiUrl + 'referencedata/payerclasses';
    return this.http.get<any[]>(url);
  }

  // Get the master Payer Type list from reference data
  getPayerTypes(): Observable<any[]> {
    let url = configuration.apiUrl + 'referencedata/payertypes';
    return this.http.get<any[]>(url);
  }

  // Get the master Payer Plan list from reference data
  getPayerPlans(): Observable<any[]> {
    let url = configuration.apiUrl + 'referencedata/payerplans';
    return this.http.get<any[]>(url);
  }

  getEntityTypeConfig(): Observable<IEntityTypeConfig> {
    let url = configuration.apiUrl + 'referencedata/entitytypes';
    // append facility as query param
    const separator = url.includes('?') ? '&' : '?';
    url = `${url}${separator}facilityId=${sessionStorage.getItem('FacilityId')}`;
    return this.http.get<IEntityTypeConfig>(url);
  }
}
